import { useState } from "react";

/**
 * Returns a stateful value, and a function to update it.
 */

const useModalState = (defaultState: boolean = false): [boolean, (state: boolean) => void] => {
  const [openModal, setOpenModal] = useState(defaultState);

  function toggleModal(state: boolean) {
    setOpenModal(state);
  }

  return [openModal, toggleModal];
};

export default useModalState;
